import * as RxTooltip from '@radix-ui/react-tooltip';

import { Arrow } from './Arrow';

interface TimeProps {
  open: boolean;
  value: number;
  children: React.ReactNode;
  format?: (value: number) => string;
}

export const ValueInfo = ({ open, value, children, format }: TimeProps) => {
  return (
    <RxTooltip.Provider delayDuration={100}>
      <RxTooltip.Root open={open} disableHoverableContent>
        <RxTooltip.Trigger onFocus={(e) => e.preventDefault()} asChild>
          {children}
        </RxTooltip.Trigger>
        <RxTooltip.Portal>
          <RxTooltip.Content
            className="bg-gray-90 relative z-10000 rounded-lg px-2 py-1 text-[12px]/[12px] text-white"
            side="top"
            avoidCollisions={false}
            sideOffset={8}
          >
            <Arrow />
            {format ? format(value) : value}
          </RxTooltip.Content>
        </RxTooltip.Portal>
      </RxTooltip.Root>
    </RxTooltip.Provider>
  );
};
